import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "customer-service"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "联系客服", -1);
import { store } from "./utils/store";
import useClipboard from "vue-clipboard3";

// 点击复制

export default {
  __name: 'App',
  setup(__props) {
    function touchCopy() {
      // 调用
      copy(store.config.share_url || window.location.origin);
    }
    // 使用插件
    const {
      toClipboard
    } = useClipboard();
    const copy = async msg => {
      try {
        // 复制
        await toClipboard(msg);
        alert("链接已复制到剪贴板!");
        // 复制成功
      } catch (e) {
        // 复制失败
      }
    };
    const contactCustomerService = () => {
      window.location.href = store.config.service_url;
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_van_button, {
        type: "primary",
        onClick: touchCopy
      }, {
        default: _withCtx(() => [_createTextVNode("点击获取分享链接")]),
        _: 1
      })]), _hoisted_2, _createElementVNode("div", null, [_createVNode(_component_van_image, {
        class: "img",
        fit: "cover",
        src: _unref(store).config.h5_logo
      }, null, 8, ["src"]), _createVNode(_component_van_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => contactCustomerService())
      }, {
        default: _withCtx(() => [_createTextVNode("联系客服")]),
        _: 1
      })])])], 64);
    };
  }
};